module.exports = __webpack_public_path__ + "img/mesa_el_m.e5d4878a.png";